/**
 * Namespaced, failure-tolerant local storage.
 *
 * Preferences (favourites, recents, saved views, sidebar width) are a nicety:
 * losing them must never break the app, and a blocked storage partition —
 * private browsing, a locked-down corporate profile — is common enough that
 * every read and write has to survive throwing.
 *
 * Keys are scoped by user id so two people sharing a workstation do not inherit
 * each other's saved views.
 */

const PREFIX = 'erpx.web'

export function scopedKey(name: string, userId?: number | string | null): string {
  const scope = userId === null || userId === undefined || userId === '' ? 'anon' : String(userId)
  return `${PREFIX}.${scope}.${name}`
}

export function readJson<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key)
    if (raw === null) return fallback
    return JSON.parse(raw) as T
  } catch {
    return fallback
  }
}

export function writeJson(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch {
    // Quota exceeded or storage blocked — the in-memory value still stands.
  }
}

export function removeKey(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch {
    // Nothing to do.
  }
}
